module.exports = __webpack_public_path__ + "static/img/606a5fa499c65bcefc092a0a5e85fa01.4a69a63.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/606a5fa499c65bcefc092a0a5e85fa01.webp
// module id = U2sw
// module chunks = 0